import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'iconoir-react';

function GrubInfo() {
  const navigate = useNavigate();

  return (
    <div style={{
      minHeight: '100vh',
      background: '#000',
      color: '#fff',
      display: 'flex',
      flexDirection: 'column',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      {/* Header */}
      <div style={{ padding: '16px 20px', display: 'flex', alignItems: 'center' }}>
        <button
          onClick={() => navigate(-1)}
          style={{ background: 'none', border: 'none', color: '#fff', cursor: 'pointer', padding: '8px' }}
        >
          <ArrowLeft />
        </button>
      </div>

      {/* Content */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '40px 24px', textAlign: 'center' }}>
        
        {/* Logo */}
        <img
          src={require('../assets/powered-by-grub_whte.png')}
          alt="GRUB Digital"
          style={{ width: '180px', marginBottom: '40px' }}
        />

        {/* Headline */}
        <h1 style={{ fontSize: '28px', fontWeight: 700, margin: '0 0 12px', letterSpacing: '-0.5px' }}>
          Tecnologia para restaurantes
        </h1>
        
        <p style={{ fontSize: '16px', color: '#999', maxWidth: '400px', lineHeight: 1.5, margin: '0 0 48px' }}>
          Cardápio digital, pedidos por mesa, delivery, PDV, estoque e muito mais. Tudo em uma plataforma.
        </p>

        {/* Features */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '16px', maxWidth: '400px', width: '100%', marginBottom: '48px' }}>
          {[
            { icon: '📱', label: 'Cardápio Digital' },
            { icon: '🛵', label: 'Delivery' },
            { icon: '🧾', label: 'PDV & Caixa' },
            { icon: '📊', label: 'Relatórios' },
            { icon: '📦', label: 'Estoque' },
            { icon: '⭐', label: 'Fidelidade' },
          ].map((item, i) => (
            <div key={i} style={{
              background: '#1a1a1a',
              borderRadius: '10px',
              padding: '14px',
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              fontSize: '13px',
              fontWeight: 500,
              color: '#ccc'
            }}>
              <span style={{ fontSize: '18px' }}>{item.icon}</span>
              {item.label}
            </div>
          ))}
        </div>

        {/* CTA */}
        <a
          href="https://grub.digital"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: 'inline-block',
            padding: '14px 32px',
            background: '#fff',
            color: '#000',
            borderRadius: '8px',
            fontWeight: 700,
            fontSize: '14px',
            textDecoration: 'none',
            letterSpacing: '0.3px'
          }}
        >
          CONHECER A GRUB
        </a>

        <p style={{ fontSize: '12px', color: '#555', marginTop: '16px' }}>
          grub.digital
        </p>
      </div>
    </div>
  );
}

export default GrubInfo;
